import { useEffect, useState } from "react";
import { Film, Lock } from "lucide-react";
import Seo from "../components/Seo";
import { Reveal } from "../components/Reveal";
import client, { API } from "../lib/api";

export default function Bts() {
  const [clips, setClips] = useState(null);

  useEffect(() => {
    client.get("/site").then((r) => setClips(r.data.bts_clips || [])).catch(() => setClips([]));
  }, []);

  return (
    <main className="pt-16" data-testid="bts-page">
      <Seo title="Behind the Scenes" description="Rehearsal clips and behind-the-scenes moments from Laugh at L.A." />
      <section className="spotlight-bg border-b border-white/5">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 py-20 sm:py-24">
          <Reveal>
            <p className="text-xs font-semibold uppercase tracking-[0.3em] text-[#F59E0B]">Behind the Scenes</p>
            <h1 className="mt-3 font-display text-5xl sm:text-7xl text-white neon-red">Before the lights come up.</h1>
          </Reveal>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 sm:px-6 py-16">
        {clips === null ? null : clips.length === 0 ? (
          <Reveal>
            <div className="mx-auto max-w-xl rounded-2xl border border-dashed border-white/20 bg-[#181824]/50 p-12 text-center" data-testid="bts-empty">
              <Lock size={32} className="mx-auto text-[#F59E0B]" />
              <h2 className="mt-4 font-display text-3xl text-white">Rehearsal room is closed</h2>
              <p className="mt-3 text-sm text-gray-400 leading-relaxed">
                Approved rehearsal clips are on their way through the edit bay. This gallery opens the moment they're cleared — check back after the next taping.
              </p>
            </div>
          </Reveal>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="bts-gallery">
            {clips.map((clip, i) => (
              <Reveal key={clip.id} delay={i * 0.06}>
                <article className="rounded-xl border border-white/10 bg-[#181824]/70 overflow-hidden" data-testid={`bts-clip-${clip.id}`}>
                  {clip.storage_path ? (
                    <video controls preload="none" poster={clip.thumbnail || undefined} className="aspect-video w-full bg-black object-cover" data-testid={`bts-video-${clip.id}`}>
                      <source src={`${API}/clips/${clip.id}/stream`} type={clip.content_type || "video/mp4"} />
                    </video>
                  ) : (
                    <div className="flex aspect-video items-center justify-center bg-black/50">
                      <Film size={32} className="text-gray-600" />
                    </div>
                  )}
                  <div className="p-5">
                    <h3 className="font-display text-xl text-white">{clip.title}</h3>
                    <p className="mt-1 text-sm text-gray-400">{clip.caption}</p>
                  </div>
                </article>
              </Reveal>
            ))}
          </div>
        )}
      </section>
    </main>
  );
}
